import React from 'react';

const Table = (props) => {
    const{_id,name,subject,price} =props.item
    return (
        
            <tr>
            <th scope="row">{_id}</th>
            <td>{subject}</td>
            <td>{name}</td>
            <td>{price}</td>
            <td><button type="button" class="btn btn-danger">Delete</button></td>
          </tr>
        
    );
};

export default Table;